import React from 'react';
import voteService from '../services/VoteService';

/**
 * Compact vote summary badge showing most popular vote and total count
 */
const VoteSummaryBadge = ({ voteSummary, className = '' }) => {
  if (!voteSummary || voteSummary.total === 0) {
    return null;
  }

  const mostPopular = voteService.getMostPopularVote(voteSummary);
  const mostPopularData = mostPopular ? voteSummary[mostPopular] : null;

  if (!mostPopular || !mostPopularData) {
    return null;
  }

  const emoji = voteService.getVoteEmoji(mostPopular);
  const color = voteService.getVoteColor(mostPopular);

  return (
    <div 
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${className}`}
      style={{
        backgroundColor: `${color}15`,
        color: color,
        border: `1px solid ${color}30`
      }}
      title={`Most popular: ${mostPopular} (${mostPopularData.count}/${voteSummary.total} votes)`}
    >
      <span className="mr-1">{emoji}</span>
      <span className="font-medium">{mostPopularData.count}</span>
      <span className="mx-1">/</span>
      <span>{voteSummary.total}</span>
    </div>
  );
};

export default VoteSummaryBadge;